// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"_3FM2S","rtoControlFlow":"oeV-p","registrationWrapper":"_t9lt","regNoPlate":"_2BrY6"};